export default __webpack_public_path__ + "static/media/134.29aadd36.gif";